import { Link } from "react-router-dom";
import { ImageOff, MapPin, ArrowRight } from "lucide-react";
import { photoSrc } from "../lib/api";
import { TypeBadge, MinorBadge, StatusBadge } from "./Badges";

export function CaseCard({ c }) {
  const src = photoSrc(c.photo_url);
  const name = [c.first_name, c.last_name].filter(Boolean).join(" ") || "Sin nombre";
  return (
    <Link to={`/caso/${c.public_case_code}`} data-testid={`case-card-${c.public_case_code}`}
      className="group block bg-white border border-[#E2E8F0] rounded-xl overflow-hidden hover:shadow-sm hover:border-[#1E3A8A] transition-all">
      <div className="aspect-[4/3] bg-[#F1F5F9] flex items-center justify-center overflow-hidden">
        {src ? (
          <img src={src} alt={name} className="w-full h-full object-cover" loading="lazy" />
        ) : (
          <ImageOff className="w-10 h-10 text-[#CBD5E1]" />
        )}
      </div>
      <div className="p-3 space-y-2">
        <div className="flex items-center gap-1.5 flex-wrap">
          <TypeBadge caseType={c.case_type} label={c.case_type_label} />
          {c.is_minor_case && <MinorBadge />}
        </div>
        <h3 className="font-heading font-semibold text-[#0F172A] leading-tight">{name}</h3>
        <p className="text-sm text-[#475569]">
          {c.approximate_age != null ? `${c.approximate_age} años aprox.` : (c.age_range || "Edad desconocida")}
        </p>
        {c.approximate_zone && (
          <p className="text-sm text-[#475569] flex items-center gap-1">
            <MapPin className="w-3.5 h-3.5" /> {c.approximate_zone}
          </p>
        )}
        {c.status_label && <StatusBadge label={c.status_label} />}
        <div className="flex items-center justify-between pt-1">
          <span className="text-xs text-[#94A3B8] font-mono">{c.public_case_code}</span>
          <span className="text-sm font-semibold text-[#1E3A8A] flex items-center gap-0.5">
            Ver ficha <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
          </span>
        </div>
      </div>
    </Link>
  );
}
